export default "__VITE_ASSET__CvZG$7nR__"